export default __webpack_public_path__ + "images/3814195d6cedc01a40883a6a7ed1e1e9.svg";